import React, { useEffect } from 'react'
import { Col, Row } from 'react-bootstrap'
import Iframe from 'react-iframe'
const MyIFrame = ({urlDocumento, op, prototipo}) => {
 
  return (
    <div>
       {op==='cd-upload' && prototipo!==1 && prototipo!==4?<Row className='mt-1'>
    <Col md='3'>
    </Col>
    <Col md='6'>
       <Iframe url={urlDocumento}
             width="600px"
             height="450px"
             id="myId"
             className="myClassname"
             display="initial"
             position="relative"/>
       </Col>
       <Col md='3'>
    </Col>
  </Row>:<Row className='mt-3'>
    
    <Col md='12'>
       {urlDocumento && <Iframe url={urlDocumento}
             width="100%"
             height="600px"
             id="myId"
             className="myClassname"
             display="initial"
             position="relative"/>}
       </Col>
       <Col md='3'>
    </Col>
  </Row>}
  </div>
  )
}

export default MyIFrame